import React from 'react';
import { Row, Col } from 'antd';

import { ConfirmPage, StyledCard, Tip, LinkItem } from './Styles';
import SignUpImage from 'assets/images/group.svg';

export default () => {
  return (
    <ConfirmPage>
      <Row justify='center' align='middle'>
        <Col flex='376px'>
          <StyledCard cover={<img src={SignUpImage} alt='' />}>
            <p>
              Thank you for submitting your information. An email has been sent
              to your inbox. Please follow the instruction to verify your
              details.
            </p>
            <Tip>
              Already have an account?
              <LinkItem to='/login'>Login</LinkItem>
            </Tip>
          </StyledCard>
        </Col>
      </Row>
    </ConfirmPage>
  );
};
